import ComingSoonView from './ComingSoon.view';
import ComingSoon from './ComingSoon';

export { ComingSoonView };
export default ComingSoon;
